import React, { useState } from "react";
import "./OutpatientNavigator.css";
import logo2 from "./logo2.png";
import lukemason from "./lukemason.png";
import {
  generateProviderMeetingURL,
  generatePatientMeetingURL,
  getCurrentSessionId,
} from "./utils/meetingEncryptor";

import SendJoinLinkModal from "./SendJoinLinkModal";
import HandoffModal from "./HandoffModal";
import { useNavigate } from "react-router-dom";


const OutpatientNavigator = ({ patient, onBack }) => {

  const [activeTab, setActiveTab] = useState("Virtual Visit");

  const [showSendLink, setShowSendLink] = useState(false);

  const [showHandoff, setShowHandoff] = useState(false);

  const navigate = useNavigate();

  const handleNavigateToReports = () => navigate("/outpatient-schedule");
  const handleNavigateToDashboard = () => navigate("/patient-list");
  const handleNavigateToMonitor = () => navigate("/video-wall");
  const handleNavigateToCensus = () => navigate("/patient-list");

  const [visitStatus, setVisitStatus] = useState("Ready");

  const [timeline, setTimeline] = useState([
    {
      label: "Appointment Checked In",
      complete: true,
    },
    {
      label: "Insurance Verified",
      complete: true,
    },
    {
      label: "Consent Received",
      complete: true,
    },
    {
      label: "Provider Joined",
      complete: false,
    },
    {
      label: "Patient Joined",
      complete: false,
    },
    {
      label: "Visit Complete",
      complete: false,
    },
  ]);


  /*
  ----------------------------------------------------
  Launch Provider Video Visit
  ----------------------------------------------------
  */

  const handleLaunchVisit = () => {

    const session = getCurrentSessionId();

    console.log(
      "Provider Session:",
      session
    );


    const url =
      generateProviderMeetingURL(
        "Dr. Halpert"
      );


    setVisitStatus("Provider Joined");


    setTimeline(prev =>
      prev.map(item =>
        item.label === "Provider Joined"
          ? {
              ...item,
              complete: true,
            }
          : item
      )
    );


    window.open(
      url,
      "_blank"
    );

  };


  /*
  ----------------------------------------------------
  Handoff
  ----------------------------------------------------
  */

  const handleHandoffComplete = () => {

    setVisitStatus(
      "Mobile Device Connected"
    );

  };


  /*
  ----------------------------------------------------
  Patient Join Link Generated
  ----------------------------------------------------
  */

  const handleLinkSent = () => {


    setVisitStatus(
      "Patient Invitation Sent"
    );


    setTimeline(prev =>
      prev.map(item =>
        item.label === "Patient Joined"
          ? {
              ...item,
              complete: true,
            }
          : item
      )
    );


  };


  const patientData = patient || {

    patient:
      "John Smith",

    visit:
      "Annual Wellness Visit",

    time:
      "10:15 AM",

    status:
      "Ready",

  };


  return (

    <div className="outpatient-page">


      {/* HEADER */}

      <div className="outpatient-header">

        <img
          src={logo2}
          alt="Verge Nursing"
          className="outpatient-logo"
        />


        <div>

          <h1>
            Patient Chart
          </h1>

          <p>
            Ambulatory Virtual Care Encounter
          </p>

        </div>

      </div>
      
      {/* TOP RIGHT NAV */}
      <div className="top-nav-buttons">
        <button
          className="top-nav-btn"
          onClick={onBack}
        >
          Outpatient Schedule
        </button>
        <button onClick={handleNavigateToDashboard} className="top-nav-btn">Inpatient Census</button>
        <button onClick={handleNavigateToMonitor} className="top-nav-btn">Monitor Rooms</button>
      </div>

      {/* PATIENT BANNER */}


      <div className="patient-banner">


        <div className="patient-demographics">

          <img
            src={lukemason}
            alt={`${patientData.patient} avatar`}
            className="patient-avatar"
          />

          <div className="patient-details">

            <h2>
              {patientData.patient}
            </h2>

            <p>
              DOB: 02/14/1978
            </p>

            <p>
              MRN: 456812
            </p>

          </div>

        </div>


        <div>

          <p>
            <strong>
              Appointment
            </strong>
          </p>

          <p>
            {patientData.visit}
          </p>

        </div>


        <div>

          <p>
            <strong>
              Provider
            </strong>
          </p>

          <p>
            Dr. James Halpert
          </p>

        </div>


        <div>

          <p>
            <strong>
              Status
            </strong>
          </p>


          <span className="visit-status">

            {visitStatus}

          </span>


        </div>


      </div>



      {/* TABS */}


      <div className="outpatient-tabs">


        {
          [
            "Summary",
            "Medications",
            "Problems",
            "Allergies",
            "Labs",
            "Virtual Visit",
          ].map(tab => (

            <div

              key={tab}

              className={
                activeTab === tab
                ? "outpatient-tab active"
                : "outpatient-tab"
              }

              onClick={() =>
                setActiveTab(tab)
              }

            >

              {tab}

            </div>


          ))
        }

      </div>
      {/* MAIN CONTENT */}

      <div className="outpatient-content">


        {/* SUMMARY TAB */}

        {activeTab === "Summary" && (

          <>

            <div className="outpatient-card">

              <h2>
                Visit Summary
              </h2>


              <div className="summary-grid">


                <div>

                  <label>
                    Visit Type
                  </label>

                  <p>
                    {patientData.visit}
                  </p>

                </div>


                <div>

                  <label>
                    Appointment Time
                  </label>

                  <p>
                    {patientData.time}
                  </p>

                </div>


                <div>

                  <label>
                    Location
                  </label>

                  <p>
                    Virtual Care Clinic
                  </p>

                </div>


                <div>

                  <label>
                    Encounter Type
                  </label>

                  <p>
                    Scheduled Telehealth
                  </p>

                </div>


              </div>

            </div>



            <div className="outpatient-card">


              <h2>
                Problems
              </h2>


              <div className="problem-item">

                Hypertension

              </div>


              <div className="problem-item">

                Type 2 Diabetes Mellitus

              </div>


              <div className="problem-item">

                Hyperlipidemia

              </div>


            </div>



            <div className="outpatient-card">


              <h2>
                Recent Activity
              </h2>


              <p>
                Last encounter: Primary Care Follow-up
              </p>


              <p>
                Last updated: 07/15/2026
              </p>


            </div>


          </>

        )}




        {/* VIRTUAL VISIT TAB */}

        {activeTab === "Virtual Visit" && (

          <div className="outpatient-card virtual-card">


            <h2>
              Virtual Visit
            </h2>


            <div className="virtual-summary">


              <div>

                <label>
                  Patient
                </label>

                <p>
                  {patientData.patient}
                </p>

              </div>


              <div>

                <label>
                  Provider
                </label>

                <p>
                  Dr. James Halpert
                </p>

              </div>


              <div>

                <label>
                  Appointment
                </label>

                <p>
                  {patientData.time}
                </p>

              </div>


              <div>

                <label>
                  Visit Status
                </label>

                <p>
                  {visitStatus}
                </p>

              </div>


            </div>




            <div className="virtual-actions">


              <button

                className="launch-btn"

                onClick={handleLaunchVisit}

              >

                Launch Video Visit

              </button>



              <button

                className="handoff-btn"

                onClick={() =>
                  setShowHandoff(true)
                }

              >

                Handoff to Mobile

              </button>




              <button

                className="link-btn"

                onClick={() =>
                  setShowSendLink(true)
                }

              >

                Send Direct Join Link

              </button>



            </div>



          </div>


        )}





        {/* MEDICATIONS */}

        {activeTab === "Medications" && (

          <div className="outpatient-card">

            <h2>
              Medications
            </h2>


            <div className="med-item">
              Lisinopril 20mg Daily
            </div>

            <div className="med-item">
              Metformin 500mg BID
            </div>

            <div className="med-item">
              Rosuvastatin 10mg Daily
            </div>


          </div>

        )}





        {/* PROBLEMS */}

        {activeTab === "Problems" && (

          <div className="outpatient-card">

            <h2>
              Problem List
            </h2>


            <div className="problem-item">
              Essential Hypertension
            </div>

            <div className="problem-item">
              Type 2 Diabetes Mellitus
            </div>

            <div className="problem-item">
              Chronic Kidney Disease Stage 2
            </div>


          </div>

        )}





        {/* ALLERGIES */}

        {activeTab === "Allergies" && (

          <div className="outpatient-card">

            <h2>
              Allergies
            </h2>


            <div className="allergy-item">

              Penicillin

              <span>
                Rash
              </span>

            </div>


          </div>

        )}





        {/* LABS */}

        {activeTab === "Labs" && (

          <div className="outpatient-card">

            <h2>
              Recent Labs
            </h2>


            <div className="lab-row">

              <span>
                A1C
              </span>

              <strong>
                7.2 %
              </strong>

            </div>


            <div className="lab-row">

              <span>
                LDL
              </span>

              <strong>
                98 mg/dL
              </strong>

            </div>


            <div className="lab-row">

              <span>
                Creatinine
              </span>

              <strong>
                1.1 mg/dL
              </strong>

            </div>


          </div>

        )}



        {/* VISIT TIMELINE */}

        <div className="outpatient-card timeline-card">


          <h2>
            Visit Progress
          </h2>


          <div className="timeline">


            {timeline.map((item,index)=>(


              <div

                key={index}

                className={
                  item.complete
                  ? "timeline-item complete"
                  : "timeline-item"
                }

              >

                <span>

                  {
                    item.complete
                    ? "✓"
                    : "○"
                  }

                </span>


                {item.label}


              </div>


            ))}


          </div>


        </div>



      </div>




      {
        showSendLink && (

          <SendJoinLinkModal

            patient={patientData.patient}

            onClose={() =>
              setShowSendLink(false)
            }

            onSent={handleLinkSent}

          />

        )
      }



      {
        showHandoff && (

          <HandoffModal

            onClose={() =>
              setShowHandoff(false)
            }

            onComplete={
              handleHandoffComplete
            }

          />

        )
      }


    </div>

  );

};


export default OutpatientNavigator;